import React, { useState } from "react";
import img1 from "../../assets/images/Home/New1.webp";
import img2 from "../../assets/images/Home/New2.webp";
import img3 from "../../assets/images/Home/New3.webp";
import img11 from "../../assets/images/Home/Publicationnew.jpg";
import img44 from "../../assets/images/Home/videogallery.jpg";
import img33 from "../../assets/images/Home/gallerynewimg.jpg";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import logo1 from "../../assets/images/Scoll_Logo/Archology-logo.jpg"
import logo2 from "../../assets/images/Scoll_Logo/Culturalindia.jpg"
import logo3 from "../../assets/images/Scoll_Logo/weblink1.png"
import logo4 from "../../assets/images/Scoll_Logo/weblink2.png"
import logo5 from "../../assets/images/Scoll_Logo/weblink3.png"
import logo6 from "../../assets/images/Scoll_Logo/weblink4.png"
import logo7 from "../../assets/images/Scoll_Logo/weblink5.png"



const Homesec4 = () => {
    const selectedLang = useSelector((state) => state.language.selectedLang);
    // const [isPaused, setIsPaused] = useState(false);
    // const sliderRef = useRef(null);

    const content = {
        English: {
            newsHeading: "News & Updates",
            resourcesHeading: "Resources",
            readmore: "Read More",
            cards: [
                {
                    id: 'en_card_1',
                    image: img1,
                    description: "Maharashtra seeks custodianship of ASI-protected forts for better conservation.",
                },
                {
                    id: 'en_card_2',
                    image: img2,
                    description: "Maha archaeology department confirms Stone Age tools at Bhatala & Mowad, raises alarm over illegal mining.",
                },
                {
                    id: 'en_card_3',
                    image: img3,
                    description: "District-level committee formed to protect Maharashtra’s forts from encroachment.",
                },
            ],
            resources: [
                { id: 'en_pub', img: img11, title: "Publication", link: "/publication" },
                { id: 'en_photo', img: img33, title: "Photo Gallery", link: "/gallery" },
                { id: 'en_video', img: img44, title: "Video Gallery", link: "/gallery" },
            ],
        },
        मराठी: {
            newsHeading: "बातम्या आणि अपडेट्स",
            resourcesHeading: "संसाधने",
            readmore: "पुढे वाचा",
            cards: [
                {
                    id: 'mr_card_1',
                    image: img1,
                    description: "चांगल्या संवर्धनासाठी महाराष्ट्राला एएसआय-संरक्षित किल्ल्यांच्या संरक्षणाची आवश्यकता आहे.",
                },
                {
                    id: 'mr_card_2',
                    image: img2,
                    description: "महापुरातत्त्व विभागाने भटाळा आणि मोवाड येथे पाषाणयुगीन अवजारांची पुष्टी केली आहे, त्यामुळे बेकायदेशीर खाणकामाबद्दल चिंता व्यक्त केली आहे.",
                },
                {
                    id: 'mr_card_3',
                    image: img3,
                    description: "महाराष्ट्रातील किल्ल्यांचे अतिक्रमण होण्यापासून संरक्षण करण्यासाठी जिल्हास्तरीय समिती स्थापन.",
                },
            ],
            resources: [
                { id: 'mr_pub', img: img11, title: "प्रकाशने", link: "/publication" },
                { id: 'mr_photo', img: img33, title: "छायाचित्र दालन", link: "/gallery" },
                { id: 'mr_video', img: img44, title: "चलचित्र दालन", link: "/gallery" },
            ],
        },
    };

    const langContent = content[selectedLang];

    const allCards = [];
    for (let i = 0; i < 4; i++) {
        langContent.cards.forEach((card) => {
            allCards.push({
                ...card,
                id: `${card.id}_copy${i}`, // unique key for each duplicate
            });
        });
    }

    const logoLinks = {
        logo1: "https://asi.nic.in/",
        logo2: "https://culture.gov.in/",
        logo3: "https://maharashtra.gov.in/1125/Home",
        logo4: "https://www.india.gov.in/",
        logo5: "https://www.mygov.in/",
        logo6: "https://www.digitalindia.gov.in/",
        logo7: "https://aaplesarkar.mahaonline.gov.in/en",
    };

    const handleLogoClick = (logoId) => {
        const url = logoLinks[logoId];
        if (!url) return;

        const msg =
            selectedLang === "English"
                ? "This link will open in a new window. Do you want to proceed?"
                : "नवीन विंडोमध्ये उघडणारे बाह्य संकेतस्थळ. आपण पुढे चालवू इच्छिता?";

        if (window.confirm(msg)) {
            window.open(url, "_blank");
        }
    };

    // keyboard handler: Space / Enter toggles pause
    // const handleKeyDown = (e) => {
    //     if (e.key === " " || e.key === "Spacebar" || e.key === "Enter") {
    //         e.preventDefault();
    //         setIsPaused((p) => !p);
    //     }
    // };

    const logos = [logo1, logo2, logo3, logo4, logo5, logo6, logo7];
    const visibleCount = 5; // number of logos visible at once
    const [currentIndex, setCurrentIndex] = useState(0); // tracks leftmost visible logo
    const [enableTransition, setEnableTransition] = useState(true);
    const totalLogos = logos.length;
    // const extendedLogos = [...logos, ...logos, ...logos];

    React.useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prev) => prev + 1);
        }, 2000);

        return () => clearInterval(interval);
    }, []);

    React.useEffect(() => {
        if (currentIndex === totalLogos) {
            // Disable animation, reset position instantly
            setTimeout(() => {
                setEnableTransition(false);
                setCurrentIndex(0);
            }, 500);
        }

        // Re-enable animation after reset
        if (currentIndex === 0) {
            setTimeout(() => {
                setEnableTransition(true);
            }, 50);
        }
    }, [currentIndex, totalLogos]);



    return (
        <>
            {/* News & Updates Section */}
            {/* <div className="bg-white py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-10">
                        <h2 className="text-3xl sm:text-4xl md:text-5xl mb-3">
                            {langContent.newsHeading}
                        </h2>
                    </div>

                    <div className="w-full overflow-hidden">
                        <section
                            ref={sliderRef}
                            aria-label={`${langContent.newsHeading} slider`}
                            onMouseEnter={() => setIsPaused(true)}
                            onMouseLeave={() => setIsPaused(false)}
                            onFocus={() => setIsPaused(true)}
                            onBlur={() => setIsPaused(false)}
                            className={`flex gap-4 w-max animate-slide`}
                            style={{
                                animationPlayState: isPaused ? "paused" : "running",
                            }}
                        >
                            {allCards.map((card) => (
                                <button
                                    key={card.id}
                                    type="button"
                                    onKeyDown={handleKeyDown}
                                    className="flex flex-col sm:flex-row w-[250px] md:w-[400px] lg:w-[450px] sm:h-[220px] border border-orange-400 rounded-xl shadow-md overflow-hidden cursor-pointer text-left focus:outline-none"
                                    style={{ background: "#F6F6EC" }}
                                >
                                    <img
                                        src={card.image}
                                        alt={`card-${card.id}`}
                                        className="w-full sm:w-1/2 h-[180px] sm:h-full object-cover sm:rounded-l-xl"
                                    />
                                    <div className="sm:w-1/2 w-full flex flex-col justify-between items-start p-4 sm:h-full">
                                        <p className="text-gray-700 text-sm text-left mb-4">
                                            {card.description}
                                        </p>
                                        <span
                                            className="no-dark-bg allow-bg-yellow px-4 py-2 text-sm font-medium text-white rounded-full hover:bg-orange-600 transition inline-block"
                                            style={{ background: "#DD9827" }}
                                        >
                                            {langContent.readmore}
                                        </span>
                                    </div>
                                </button>
                            ))}
                        </section>
                    </div>
                </div>*/}

            {/* Animation */}
            {/* <style>
                    {`
                        @keyframes slide {
                            0% { transform: translateX(0); }
                            100% { transform: translateX(-50%); }
                        }
                        .animate-slide {
                            animation: slide 50s linear infinite;
                            width: max-content;
                        }
                    `}
                </style>
            </div> */}



            {/* Resources Section */}
            <div className="relative w-full py-10 md:py-12 lg:py-20 px-4 sm:px-6 lg:px-16 overflow-hidden -mt-10 -mb-10">
                {/* Background Image */}
                {/* <div className="absolute inset-0 z-0">
                    <img
                        src={bg}
                        alt="Background"
                        className="w-full h-full object-cover opacity-20"
                    />
                </div> */}

                {/* Foreground Content */}
                <div className="relative z-10 max-w-7xl mx-auto text-center no-dark-bg xl:px-28 xl:-mt-16">
                    <h2 className="text-xl sm:text-2xl md:text-3xl mb-3">
                        {langContent.resourcesHeading}
                    </h2>
                    <p className="text-gray-700 text-base sm:text-lg mb-8">
                        {langContent.resourcesSubheading}
                    </p>

                    {/* Resource Cards */}
                    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 justify-items-center">
                        {langContent.resources.map((card, index) => (
                            <Link
                                to={card.link}
                                key={card.id}
                                className={`group relative w-full max-w-[160px] sm:max-w-[200px] md:max-w-[240px] h-[250px] sm:h-[280px] md:h-[360px] rounded-lg overflow-hidden shadow-md cursor-pointer transition-transform duration-300 hover:scale-[1.02]
                                ${index === 2
                                        ? "col-span-2 flex justify-center lg:col-span-1"
                                        : ""
                                    }`}>
                                <img
                                    src={card.img}
                                    alt={card.title}
                                    className="w-full h-full object-cover absolute top-0 left-0 transition-transform duration-500 ease-in-out group-hover:scale-110"
                                />
                                <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-black to-transparent pointer-events-none" />
                                <div className="absolute bottom-0 w-full text-white text-left py-2 px-3 flex justify-between items-center z-10">
                                    <p className="text-sm tracking-wider">{card.title}</p>
                                    <p className="text-lg transform translate-x-[-8px] opacity-0 group-hover:translate-x-0 group-hover:opacity-100 transition-all duration-500 ease-in-out">
                                        →
                                    </p>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>

            </div>
            {/* Logos Marquee Section */}
            <div className="relative w-full py-1 sm:py-4 md:py-6 bg-white overflow-hidden">
                <div
                    className={`flex ${enableTransition
                        ? "transition-transform duration-500 ease-linear"
                        : ""
                        }`}
                    style={{
                        transform: `translateX(-${currentIndex * (100 / visibleCount)}%)`,
                    }}
                >
                    {[...logos, ...logos].map((logo, index) => {
                        const logoId = `logo${(index % logos.length) + 1}`; // logo1, logo2, … logo7, repeating
                        return (
                            <div
                                key={index}
                                className="flex-shrink-0 w-1/5 flex items-center justify-center cursor-pointer"
                                onClick={() => handleLogoClick(logoId)}
                            >
                                <img
                                    src={logo}
                                    alt={`logo-${index}`}
                                    className="object-contain h-20 sm:h-24"
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default Homesec4;
